<template lang="pug">
form(
    ref="validator"
    class="tl-form-validator"
    @validated="(val) => handleValid(val)"
)
    slot
</template>

<script setup>
import { ref } from 'vue'
import { useEventBus } from '@vueuse/core'

const validator = ref(null)
const validatedFields = ref([])

const handleValid = (val) => validatedFields.value.push(val.detail)

const findFields = (children) => {
    const out = []

    if (!children?.length) return out
    for (let i = 0; i < children.length; i += 1) {
        const child = children[i]
        if ('formValidator' in child.dataset) out.push(child)
        else out.push(...findFields(child.children))
    }
    return out
}

const validate = () => {
    validatedFields.value = []
    const fieldsToValidate = findFields(validator.value.children)

    for (let i = 0; i < fieldsToValidate.length; i += 1) {
        const field = fieldsToValidate[i]
        useEventBus(`validate-${field.id}`).emit()
    }
    return validatedFields.value.filter((v) => v === true).length === fieldsToValidate.length
}

const clearErrorFields = () => {
    const fieldsToValidate = findFields(validator.value.children)

    for (let i = 0; i < fieldsToValidate.length; i += 1) {
        const field = fieldsToValidate[i]
        useEventBus(`clear-error-${field.id}`).emit()
    }
}

defineExpose({
    validate,
    clearErrorFields,
})
</script>
